import React from 'react';
import { Select, Spin, Table, Tooltip, Button, Icon, Input, Col, Row } from 'antd';
import ArticulosRequest from '../../services/Articulos';
import { openNotification } from '../../util/notificaciones';
import CategoriasRequest from '../../services/Categorias';
import CategorizarArticulos from './CategorizarArticulos';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;


/**
 * Clase para ver el proceso de mostrar artículos
 */
export default class Articulos extends BaseComponent {
    state = {
        filterText: "",
        arrArticulos: [],
        arrCategorias: [],
        selectedRowKeys: [],
        selectedRows: [],
        categoriaSelected: null,
        filtros: {
            filtro: undefined,
            categoria: undefined,
            page: undefined
        },
        disableApplyFilters: true,
        cargando: false,
        paginacion: {},
        modalCat: false,
    }

    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        this.setState({ cargando: true }, () => {
            ArticulosRequest.ListarArticulos(state.filtros).then(response => {
                state.arrArticulos = response.data.results
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 10,
                    showTitle: false
                }
                return CategoriasRequest.ListarCategorias();
            }).then(response => {
                state.cargando = false
                state.arrCategorias = response.data
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los artículos.", "Error al listar artículos", false)
            })
        })
    }

    /**
     * Funcion interna de ant para el manejo de los checkbox
     * @param: selectedRowKeys (la necesita ant): id de los renglones, selectedRows: toda la informacion del objeto seleccionado
     * @return: nada
     */
    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
    };

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        state.filtros.page = paginaSiguiente
        state.cargando = true
        this.setState(state, () => {
            ArticulosRequest.ListarArticulos(state.filtros, paginaSiguiente).then(response => {
                state.paginacion.current = paginaSiguiente
                state.arrArticulos = response.data.results
                state.cargando = false
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los artículos.", "Error al listar artículos", false)
            })
        })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        let buscar = false;

        if (value.trim() === "" && state.categoriaSelected === null) {
            state.disableApplyFilters = true
        } else {
            state.disableApplyFilters = false
        }
        if (value.trim() !== state.filterText.trim()) buscar = true
        state.filterText = value;
        state.filtros.filtro = value.trim() === "" ? undefined : value.trim()
        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.filtrarBack();
            }, 1000);
        }
    }

    /**
     * Función para mostrar los artículos según la categoría
     * @param: value. opción seleccionada
     * @return: nada, se establece el estado con un nuevo valor para la categoría seleccionada
     */
    onChangeCategoria = (value) => {
        let state = { ...this.state };
        state.filtros.categoria = value === undefined ? null : value;
        if (value === undefined) {
            state.categoriaSelected = null
            if (state.filterText.trim() === "") state.disableApplyFilters = true;
        } else {
            state.categoriaSelected = value
            state.disableApplyFilters = false;
        }
        this.setState(state, this.filtrarBack)
    }

    /**
     * Función que se encarga de hacer las peticion en el back para filtrar
     */
    filtrarBack = () => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }
        state.filtros.page = 1;
        state.cargando = true;

        this.setState(state, () => {
            ArticulosRequest.ListarArticulos(state.filtros).then(response => {
                state.arrArticulos = response.data.results
                state.cargando = false
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 10,
                    showTitle: false
                }
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los artículos.", "Error al listar artículos", false)
            })
        })
    }

    /**
     * Función para limpiar todos los filtros que han
     * sido manipulados por el usuario.
     * @param: nada
     * @return: nada
     */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableApplyFilters = true;
        state.filtros.categoria = undefined;
        state.filtros.filtro = undefined;
        state.filtros.page = 1;
        state.categoriaSelected = null;
        state.filterText = "";
        state.selectedRowKeys = [];
        state.selectedRows = [];
        this.setState(state, this.filtrarBack);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    /**
     * Función para mostar el modal de categorización
     * @param: nada
     * @return: nada
     */
    showModal = () => {
        this.setState({ modalCat: true })
    }

    /**
     * Función para esconder modal de categorización
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        if (value) {
            state.modalCat = false;
            state.selectedRows = [];
            state.selectedRowKeys = [];
            state.filterText = "";
            state.filtros.filtro = undefined
            if (state.categoriaSelected === null) state.disableApplyFilters = true
            this.setState(state, this.filtrarBack)
        }
        this.setState({ modalCat: false })
    }

    render() {
        const columnasArticulos = [
            {
                title: "PT",
                dataIndex: "codigo",
                key: "codigo"
            },
            {
                title: "Nombre",
                dataIndex: "descripcion",
                key: "codidescripciongo"
            },
            {
                title: "UDMP",
                dataIndex: "unidad_venta",
                key: "unidad_venta"
            },
            {
                title: "Categoría",
                dataIndex: "categoria_nombre",
                key: "categoria_nombre"
            }
        ]
        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            hideDefaultSelections: true,
            selections: [
                {
                    key: 'all-data',
                    text: 'Seleccionar todo',
                    onSelect: () => {
                        this.setState({
                            selectedRowKeys: this.state.arrArticulos.map(item => item.id),
                            selectedRows: [...this.state.arrArticulos]
                        });
                    },
                },
                {
                    key: 'un-select-all',
                    text: 'Deseleccionar todo',
                    onSelect: changableRowKeys => {
                        this.setState({ selectedRowKeys: [], selectedRows: [] });
                    },
                },
            ],
        };

        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo artículos"
                extra={
                    <div className={localStorage.getItem("role") === 'Administrador' ? '' : 'display-none'}>
                        <Button
                            className="btnVerCrearGuardar"
                            type="primary"
                            id="boton-categorizar-articulos"
                            disabled={!this.state.selectedRowKeys.length}
                            onClick={() => {
                                this.showModal();
                            }}
                        >
                            Categorizar
                        </Button>
                    </div>
                }>

                <div className="panel-block">
                    <div style={{ marginBottom: this.state.isPos ? "" : "20px" }}>
                        <Row>
                            <Col span={10}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por PT / Nombre ">
                                    <Input
                                        autoFocus={true}
                                        maxLength={50}
                                        id="input-buscar-articulos"
                                        placeholder="Buscar por PT / Nombre"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                    />
                                </Tooltip>
                            </Col>

                            <Col span={10} style={{ marginLeft: this.state.isPos ? "10px" : "20px" }} >
                                <Tooltip placement="top" title="Buscar artículos por categoría">
                                    <div className="center">Categoría:</div>
                                    <Select
                                        allowClear={true}
                                        style={{ width: '100%' }}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        defaultValue={null}
                                        showSearch
                                        id="select-buscar-categoria"
                                        defaultActiveFirstOption={false}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        value={this.state.categoriaSelected}
                                        onChange={this.onChangeCategoria}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrCategorias.length > 0 &&
                                            this.state.arrCategorias.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.descripcion}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>

                            <Col span={3}>
                                <div className="center-down" style={{ marginLeft: this.state.isPos ? "0px": ""}}>
                                    <Tooltip placement="top" title="Borrar filtros">
                                        <Button id="boton-borrar-filtros-articulos" type="default" icon="delete" className={this.state.disableApplyFilters ? 'disableBtn' : ''} style={{ width: '80%', marginLeft: '4.5%', marginBottom: "30px", marginTop: '1.3em' }} onClick={this.cleanFilters}></Button>
                                    </Tooltip>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table
                            size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={articulo => articulo.id}
                            columns={columnasArticulos}
                            dataSource={this.state.arrArticulos}
                            rowSelection={rowSelection}
                            pagination={this.state.paginacion}
                        />
                    </Spin>
                </div>
                <CategorizarArticulos
                    esconderModal={this.esconderModal}
                    visible={this.state.modalCat}
                    arrArticulos={this.state.selectedRowKeys}
                    arrCategorias={this.state.arrCategorias}
                >
                </CategorizarArticulos>
            </ResponsiveCard>
        )
    }
}
